import '../../src/App.css';
import '../../src/Css/bootstrap.min.css';
import Login from '../../src/Pages/login';
// import HomePage from './pages/index';
import HomePage from '../Pages/index';
import Loader from 'react-loader-spinner';
import Menu from '../Components/Header/Menu';
import { useState, useEffect, Fragment } from 'react';
import PopupMenu from '../Components/PopupMenu';
import ModalAboutUs from '../Components/Modals/ModalAboutUs';
import ModalDialog from '../Components/Modals/ModalDialog';
import MenuWide from '../Components/Header/MenuWide';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PrintViewer from "../Pages/PrintViewer";
import { getActiveSubsystems,  useIsMobileApp } from '../store/api/CommonFunctions';
import NoticeBoard from './pages/NoticeBoard';
import { useDispatch } from 'react-redux';
import SearchCommands from '../Pages/SearchCommands';
import { getAppConfig } from '../store/api/SystemSettingsAPI';
import UserDashboard from '../Pages/UserDashboard';
import ModalSMSTemplates from '../Components/Modals/ModalSMSTemplates';
import SearchSentSMS from '../Pages/SearchSentSMS';
import SearchReceivedSMS from '../Pages/SearchReceivedSMS';
import AddEditInterOfficeMessage from './pages/AddEditInterOfficeMessage';
import SearchInterOfficeMessages from './pages/SearchInterOfficeMessages';
import ModalFlowStages from './Components/ModalFlowStages';
import UserDashboardReport from './pages/UserDashboardReport';

const requireAuth = (setUser) => {
  const token = localStorage.getItem('token');
  if (token !== null && token) {
    setUser(token);
  } else {
    setUser(null);
  }
}


function App(props) {
  const { setModalAboutUs, setQAList } = props;
  const dispatch = useDispatch();
  const isMobile = useIsMobileApp();
  const [pending, setPending] = useState(true);
  const [currentUser, setUser] = useState(null);
  const [menuWidth, setMenuWidth] = useState(false);
  const [forgetPassword, setForgetPassword] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem("UserInfo"));
  useEffect(() => {
    requireAuth(setUser);
    setPending(false);
    dispatch(getActiveSubsystems());
    dispatch(getAppConfig());

    document.getElementById("CompanyName")?.setAttribute("systemname", "سیستم اتوماسیون اداری");
  }, []);
  return (
    <div className="App">
      <Router>
        {currentUser &&
          <Fragment>
            <ModalDialog />
            <PopupMenu />
            <div style={{ position: "relative", height: "max-content", display: "flex", paddingRight:"12px", paddingLeft:"12px" }}>
              {isMobile ? <Menu />:
                <Fragment>
                  <span style={{ fontSize: "30px", cursor: "pointer", position: "relative"}} onClick={() => { setMenuWidth("250px") }}>&#9776;</span>
                  <MenuWide menuWidth={menuWidth} setMenuWidth={setMenuWidth} currentUser={currentUser} setModalAboutUs={setModalAboutUs} menuName="Office" setQAList={setQAList} />
                </Fragment>}
            </div>
            <Switch>
              <Route path="/Office/NoticeBoard"><NoticeBoard /></Route>
              <Route path="/PrintViewer/:reportName/:designMode"><PrintViewer /></Route>
              <Route path="/SearchCommands"><SearchCommands /></Route>
              <Route path="/UserDashboard"><UserDashboard /></Route>
              <Route path="/SMSTemplates"> <ModalSMSTemplates /></Route>
              <Route path="/SearchSentSMS"><SearchSentSMS /></Route>
              <Route path="/SearchReceivedSMS"><SearchReceivedSMS /></Route>
              <Route path="/Office/AddEditInterOfficeMessage/:messageType/:messageID/:isInternal"><AddEditInterOfficeMessage /></Route>
              <Route path="/Office/SearchInterOfficeMessages"><SearchInterOfficeMessages /></Route>
              <Route path="/Office/ModalFlowStages"><ModalFlowStages /></Route>
              <Route path="/Office/UserDashboardReport"><UserDashboardReport/></Route>
              <Route path={userInfo?.HomePage === "Office" ? "/" : "/Office"}><HomePage /></Route>
            </Switch>
          </Fragment>
        }
        {pending &&
          <Loader type="BallTriangle"
            color="#bb1370"
            height={50}
            width={50} />}

        {!pending && !currentUser && !forgetPassword &&
          <Login setUser={setUser} setForgetPassword={setForgetPassword} />}
      </Router>
    </div>
  );
}

export default App;
